export const numberFormatter = new Intl.NumberFormat("en-KE", {
  style: "currency",
  currency: "KES",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function getVisiblePages(currentPage, totalPages, maxVisible = 5) {
  let start = Math.max(currentPage - Math.floor(maxVisible / 2), 0);
  let end = start + maxVisible - 1;

  if (end > totalPages) {
    end = totalPages;
    start = Math.max(end - maxVisible + 1, 0);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

export const hasLocationData = (locationData = {}) => {
  return Object.keys(locationData).length > 0;
};

export const paymentMethodEnum = {
  1: "Mpesa",
  2: "Card",
  3: "Paybill",
  4: "CashOnDelivery",
};

export const OrderStatusEnum = {
  1: { label: "Pending", class: "bg-secondary" },
  2: { label: "InventoryReserved", class: "bg-primary" },
  3: { label: "AwaitingPayment", class: "bg-warning text-dark" },
  4: { label: "AwaitingConfirmation", class: "bg-warning text-dark" },
  5: { label: "Paid", class: "bg-success" },
  6: { label: "Processing", class: "bg-info text-dark" },
  7: { label: "Shipped", class: "bg-primary" },
  8: { label: "Delivered", class: "bg-success" },
  9: { label: "Cancelled", class: "bg-danger" },
  10: { label: "PaymentFailed", class: "bg-danger" },
};
